import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'
import type { MaintenanceRequest, MaintenanceCategory } from '@/types'

interface MaintenanceResponse {
  data: MaintenanceRequest[]
}

interface AccountInfoResponse {
  maintenance_categories: MaintenanceCategory[]
}

export function useMaintenanceRequests() {
  return useQuery({
    queryKey: ['customer', 'maintenance'],
    queryFn: async () => {
      const response = await api.get<MaintenanceResponse>('/api/customer/maintenance_requests')
      return response.data.data
    },
  })
}

export function useMaintenanceCategories() {
  return useQuery({
    queryKey: ['customer', 'account_info'],
    queryFn: async () => {
      const response = await api.get<AccountInfoResponse>('/api/customer/account_info')
      return response.data.maintenance_categories
    },
  })
}

interface CreateMaintenanceInput {
  title: string
  description: string
  category: string
  category_note?: string
  image_urls?: string[]
}

export function useCreateMaintenanceRequest() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (input: CreateMaintenanceInput) => {
      const response = await api.post('/api/customer/maintenance_requests', input)
      return response.data
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['customer', 'maintenance'] })
    },
  })
}
